<template>
  <div class="ws-flex-wrap">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>